import React, { Component } from 'react';
// utils
import { COUNTRY_TAXANOMY } from '../../../../constants';
import { Translations, convertStringToArray, convertStringToArrayForOption } from '../../../../utils';
// children
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';


const CHK_BOX = 'CHECKED';
const UNCHK_BOX = 'UNCHECKED';

class ConstomerInCase extends Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  getCountryTaxonomy = (item) => {
    if (this.props.countryList !== undefined) {
      this.props.countryList.filter(countItem => {
        if ('country' in item) {
          if (countItem.id === item.country.value) {
            item.country.name = countItem.name
          }
        } else {
          if (countItem.id === item.value) {
            item.name = countItem.name
          }
        }
      })
      return item;
    }
  }

  getSalutation = (item) => {
    var currentWord = Translations(this.props.pageJson.dynamic_accordion_list_customersInCase.salutation, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    const salutation = convertStringToArrayForOption(currentWord);
    if (salutation !== undefined) {
      salutation.filter(countItem => {
        if ('title' in item) {
          if (countItem.split('=')[0] === item.title.value) {
            item.title.name = countItem.split('=')[1]
          }
        }
      })
      return item;
    }
  }

  render() {
    const { customerInCase, pageJson } = this.props;

    /*===============================================constomerInCase start from here============================*/
    const staticData = pageJson['customer_details'];
    const basicDetails = (item, staticData) => {
      return (
        <div className="basicDetails">
          <div className="basic-details-container">
            <div className="basic-detail-heading">
              {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[14]}
            </div>
            <div className="basic-detail-content">
              <dl className="dl-horizontal">
                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[8]}
                </dt>
                <dd>
                  <b>{item.registeredName !== undefined ? item.registeredName : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[10]}
                </dt>
                <dd>
                  <b>{item.countryOfIncorporation !== undefined && this.props.countryList !== undefined ? this.getCountryTaxonomy(item.countryOfIncorporation).name : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[1]}
                </dt>
                <dd>
                  <b>{item.countryOfRegistration !== undefined && this.props.countryList !== undefined ? this.getCountryTaxonomy(item.countryOfRegistration).name : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[13]}
                </dt>
                <dd>
                  <b>{item.incorporationNumber !== undefined ? item.incorporationNumber : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[6]}
                </dt>
                <dd>
                  <b>{item.dateOfIncorporation !== undefined ? item.dateOfIncorporation : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[5]}
                </dt>
                <dd>
                  <b>{item.taxNumber !== undefined ? item.taxNumber : ""}</b>
                </dd>

                {this.props.customer.roleDetails.customer === true ? '' :
                  <dt>
                    {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[17]}
                  </dt>
                }
                {this.props.customer.roleDetails.customer === true ? '' :
                  <dd>
                    <b>{item.corpStatus !== undefined ? item.corpStatus : ""}</b>
                  </dd>
                }
                {this.props.customer.roleDetails.customer === true ? '' :
                  <dt>
                    {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[18]}
                  </dt>
                }
                {this.props.customer.roleDetails.customer === true ? '' :
                  <dd>
                    <b>{item.businessSegment !== undefined && item.businessSegment.name !== undefined ? item.businessSegment.name : ""}</b>
                  </dd>
                }

                {this.props.customer.roleDetails.customer === true ? null : <React.Fragment><dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[24]}
                </dt>

                  <dd>
                    <b>{item.glcmImplementation !== undefined ? item.glcmImplementation === true ? "Yes" : "No" : ''}</b>
                  </dd></React.Fragment>}

                {item.glcmImplementation === true && !this.props.customer.roleDetails.customer ?
                  <React.Fragment>
                    <dt>
                      ClientSphere Project Number / PMP Project ID
                      {/* {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[26]} */}
                    </dt>
                    <dd>
                      <b>{item.projectNo ? item.projectNo === "CS" ? "ClientSphere Project Number" : "PMP Project ID" : ""}</b>
                    </dd>
                    {
                      item.projectNo === "CS" ?
                        <React.Fragment>
                          <dt>
                            {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[25]}
                          </dt>
                          <dd>
                            <b>{item.csProjectNumber !== undefined ? item.csProjectNumber : ""}</b>
                          </dd>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <dt>
                            PMP Project ID
                            {/* {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[27]} */}
                          </dt>
                          <dd>
                            <b>{item.cmpProjectID || ""}</b>
                          </dd>
                        </React.Fragment>
                    }
                  </React.Fragment>
                  : null
                }

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[15]}
                </dt>
                <dd>
                  <b>{item.financialInstitution !== undefined ? item.financialInstitution === true ? 'Yes' : 'No' : ""}</b>
                </dd>

                <dt>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[7]}
                </dt>
                <dd>
                  <b>{item.txtGRIDno !== undefined ? item.txtGRIDno : ""}</b>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      )
    };
    const addresses = (item, staticData) => {
      return (
        <div className="addresses">
          <div className="basic-details-container">
            <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[20]}</div>
            <div className="basic-detail-content">
              <dl className="dl-horizontal">
                <dt>{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[11]}</dt>
                <dd><b>
                  <span>
                    {item.registeredAddressData !== undefined && item.registeredAddressData.addressLine1 !== undefined ? `${item.registeredAddressData.addressLine1}` : ""}
                    {item.registeredAddressData !== undefined && item.registeredAddressData.addressLine2 !== undefined ? `,${item.registeredAddressData.addressLine2}` : ""}
                    {item.registeredAddressData !== undefined && item.registeredAddressData.addressLine3 !== undefined ? `,${item.registeredAddressData.addressLine3}` : ""}
                  </span>
                  <br />
                  <span>
                    {item.registeredAddressData !== undefined && item.registeredAddressData.city !== undefined ? `${item.registeredAddressData.city}` : ""}
                    {item.registeredAddressData !== undefined && item.registeredAddressData.state !== undefined ? `,${item.registeredAddressData.state}` : ""}
                    {item.registeredAddressData !== undefined && item.registeredAddressData.postCode !== undefined ? `,${item.registeredAddressData.postCode}` : ""}
                    {item.registeredAddressData !== undefined && item.registeredAddressData.country !== undefined && this.getCountryTaxonomy(item.registeredAddressData) !== undefined ? `,${this.getCountryTaxonomy(item.registeredAddressData).country.name}` : ""}
                  </span>
                </b></dd>
                <dt>{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[0]}</dt>
                <dd><b>
                  <span>
                    {item.businessAddressData !== undefined && item.businessAddressData.addressLine1 !== undefined ? `${item.businessAddressData.addressLine1}` : ""}
                    {item.businessAddressData !== undefined && item.businessAddressData.addressLine2 !== undefined ? `,${item.businessAddressData.addressLine2}` : ""}
                    {item.businessAddressData !== undefined && item.businessAddressData.addressLine3 !== undefined ? `,${item.businessAddressData.addressLine3}` : ""}
                  </span>
                  <br />
                  <span>
                    {item.businessAddressData !== undefined && item.businessAddressData.city !== undefined ? `${item.businessAddressData.city}` : ""}
                    {item.businessAddressData !== undefined && item.businessAddressData.state !== undefined ? `,${item.businessAddressData.state}` : ""}
                    {item.businessAddressData !== undefined && item.businessAddressData.postCode !== undefined ? `,${item.businessAddressData.postCode}` : ""}
                    {item.businessAddressData !== undefined && item.businessAddressData.country !== undefined && this.getCountryTaxonomy(item.businessAddressData) !== undefined ? `,${this.getCountryTaxonomy(item.businessAddressData).country.name}` : ""}
                  </span>
                </b></dd>
                <dt>{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[19]}</dt>
                <dd><b>
                  <span>
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.addressLine1 !== undefined ? `${item.correspondenceAddressData.addressLine1}` : ""}
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.addressLine2 !== undefined ? `,${item.correspondenceAddressData.addressLine2}` : ""}
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.addressLine3 !== undefined ? `,${item.correspondenceAddressData.addressLine3}` : ""}
                  </span>
                  <br />
                  <span>
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.city !== undefined ? `${item.correspondenceAddressData.city}` : ""}
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.state !== undefined ? `,${item.correspondenceAddressData.state}` : ""}
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.postCode !== undefined ? `,${item.correspondenceAddressData.postCode}` : ""}
                    {item.correspondenceAddressData !== undefined && item.correspondenceAddressData.country !== undefined && this.getCountryTaxonomy(item.correspondenceAddressData) !== undefined ? `,${this.getCountryTaxonomy(item.correspondenceAddressData).country.name}` : ""}
                  </span>
                </b></dd>
              </dl>
            </div>
          </div>
        </div>
      )
    };
    const primaryBusinessContacts = (item, staticData) => {

      return (
        <div className="primaryBusinessContacts">
          <div className="basic-details-container">
            <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[21]}</div>
            <div className="basic-detail-content">
              {item.primaryBusinessContactsData !== undefined && item.primaryBusinessContactsData.length > 0 ? item.primaryBusinessContactsData.map((childData, key) =>
                <dl className="dl-horizontal" key={key}>
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[12]} {key + 1}</dt>
                  <dd ><b>
                    <span>
                      {childData.title !== undefined && childData.title.name !== undefined && childData.title.name !== 'Other' ? `${this.getSalutation(childData).title.name}` : ""}
                      {childData.other !== undefined ? `${childData.other}` : ""} &nbsp;
                      {childData.firstName !== undefined ? `${childData.firstName}` : ""}&nbsp;
                      {childData.lastName !== undefined ? `,${childData.lastName}` : ""}
                      {childData.jobTitle !== undefined ? `,${childData.jobTitle}` : ''}
                    </span> <br></br>
                    <span>{childData.emailAddress !== undefined ? childData.emailAddress : ''}
                    </span>
                    <span>
                      {childData.telephoneNumber !== undefined ? `Tel:${childData.telephoneNumber}` : ''}
                    </span><br></br>
                    <span>
                      {childData.faxNumber !== undefined ? `Fax:${childData.faxNumber}` : ''}
                    </span>
                  </b></dd>
                </dl>
              ) : ""}
            </div>
          </div>
        </div>
      )
    };
    const declarationSignatories = (item, staticData) => {
      const countyTexonomy = COUNTRY_TAXANOMY;
      let countryOfIncorporation = item.countryOfIncorporation.value;
      let countryExist = countyTexonomy.indexOf(countryOfIncorporation);

      return (
        <div className="declarationSignatories">
          <div className="basic-details-container">
            <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[22]}</div>
            <div className="basic-detail-content">

              {countryExist === -1 ? '' :
                <span style={{ marginRight: '1rem' }}><i className={`icon ${item.optionalSignatory === true ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i>
                  {this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[23]}.
                </span>
              }
              {item.declarationSignatoriesData !== undefined && item.declarationSignatoriesData.length > 0 ? item.declarationSignatoriesData.map((childData, key) =>
                <dl className="dl-horizontal" key={key}>


                  {key === 0 ? <dt>{item.optionalSignatory === false || item.optionalSignatory === undefined ? `${this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[16]} ${key + 1}` :
                    `${this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[16]} ${key + 1} ${'(optional)'} `}
                  </dt> :
                    <dt>{`${this.translateWord(pageJson.dynamic_accordion_list_customersInCase.fieldLabels)[16]}  ${key + 1} ${'(optional)'}`}
                    </dt>
                  }
                  <dd><b>
                    {childData.firstName !== undefined ? childData.firstName : ""}
                    {childData.lastName !== undefined ? `,${childData.lastName}` : ""}
                    {childData.jobTitle !== undefined ? `,${childData.jobTitle}` : ""}
                  </b></dd>
                </dl>
              ) : ""}

            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="gdoc-preview-request-content">
        <span>
          {Translations(pageJson.dynamic_accordion_list_customersInCase.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        </span>
        <NavListAccordionWrapper>
          {customerInCase.length > 0 ? customerInCase.map((item, key) => (
            <NavListAccordion navAccHeading={item.registeredName} key={key}>
              <div className="basic-details-section">
                {basicDetails(item, staticData)}
                {addresses(item, staticData)}
                {primaryBusinessContacts(item, staticData)}
                {declarationSignatories(item, staticData)}
              </div>
            </NavListAccordion>
          )
          ) : ""}
        </NavListAccordionWrapper>
      </div>
    )
  }
  /*===============================================constomerInCase end from here============================*/
}
export default ConstomerInCase;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/ConstomerInCase.js